import {useQuery} from '@tanstack/react-query';
import {fetch} from '../services/ReconciliationReportsService';

// FNP-535: single-record read for the detail view. Read-only — no create, update,
// or delete mutations (the ChannelReconciler owns the lifecycle).
export const useReconciliationReport = (reportId?: string) => {

    const reportQuery = useQuery({
        queryKey: ['reconciliationReport', reportId],
        queryFn: () => fetch(reportId!),
        enabled: !!reportId
    });

    return {
        record: reportQuery.data,
        loading: reportQuery.isLoading,
        // Surface error + fetched-but-empty so the detail page can show a "not found"
        // state instead of hanging on the loader forever when an id doesn't resolve.
        // The id is composite — `reconciliation-report:{channel}#{runDate}` — so a
        // mis-encoded id would not resolve; see the encodeURIComponent note in
        // RecordsTable.
        isError: reportQuery.isError,
        notFound: reportQuery.isFetched && !reportQuery.data,
        fetchRecord: reportQuery.refetch,
    };
};
